import React, { useRef, useEffect, useState } from 'react'
import classnames from 'classnames'

import {
  IWorkspace,
} from '@SiteModules/Workspace/types'

import './WorkspaceSelectionRow.scss'

interface WorkspaceSelectionRowProps {
  readonly index: number
  readonly workspace: IWorkspace
  readonly selected: boolean
  readonly showNumberOfProjects?: boolean
  changeSelectedWorkspaces(e: React.ChangeEvent<HTMLInputElement>, workspaceId: number): void
}

const WorkspaceSelectionRow: React.FC<WorkspaceSelectionRowProps> = props => {
  const {
    index,
    selected,
    workspace,
    showNumberOfProjects,
  } = props

  const {
    id,
    attributes,
  } = workspace

  const {
    name,
    numberOfProjects,
  } = attributes

  const [hovering, setHovering] = useState(false)
  const checkboxRef = useRef<HTMLLabelElement | null>(null)

  useEffect(() => {
    if (selected) {
      checkboxRef.current?.style?.setProperty('visibility', 'visible')
    } else if (!hovering) {
      checkboxRef.current?.style?.setProperty('visibility', 'hidden')
    }
  }, [selected])

  const onMouseEnter = () => {
    checkboxRef.current?.style?.setProperty('visibility', 'visible')
    setHovering(true)
  }

  const onMouseLeave = () => {
    setHovering(false)
    if (selected) { return }

    checkboxRef.current?.style?.setProperty('visibility', 'hidden')
  }

  const handleWorkspaceSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.changeSelectedWorkspaces(e, id)
  }

  const renderCheckbox = () => {
    return (
      <label className="WorkspaceSelectionTable__checkbox" ref={checkboxRef}>
        <input
          type="checkbox"
          onChange={handleWorkspaceSelection}
          checked={selected}
        />
        <div className="WorkspaceSelectionTable__checkmark" />
      </label>
    )
  }

  return (
    <tr
      className={classnames(
        { 'WorkspaceSelectionRow__even': index % 2 === 0 },
        { 'WorkspaceSelectionRow__uneven': index % 2 === 1 }
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <td className="WorkspaceSelectionTable__check">
        {renderCheckbox()}
      </td>
      <td
        className="WorkspaceSelectionTable__workspace"
      >
        <div className="WorkspaceSelectionRow__workspace-name">
          {name}
        </div>
        {showNumberOfProjects && (
          <div className="WorkspaceSelectionRow__workspace-projects">
            {numberOfProjects === 1 ? '1 project' : `${numberOfProjects} projects`}
          </div>
        )}
      </td>
    </tr>
  )
}

export default WorkspaceSelectionRow
